/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Expires_ColInputs */

const en_admin_invite_codes_expires_col = /** @type {(inputs: Admin_Invite_Codes_Expires_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expires`)
};

const zh_admin_invite_codes_expires_col = /** @type {(inputs: Admin_Invite_Codes_Expires_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`过期`)
};

/**
* | output |
* | --- |
* | "Expires" |
*
* @param {Admin_Invite_Codes_Expires_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_expires_col = /** @type {((inputs?: Admin_Invite_Codes_Expires_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Expires_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_expires_col(inputs)
	return zh_admin_invite_codes_expires_col(inputs)
});
export { admin_invite_codes_expires_col as "admin.invite_codes.expires_col" }